import classnames from 'classnames/bind'

// Libs

// Components
import ApplyRoleEntryCard from './components/ApplyRoleEntryCard'
import Icon from '@/assets/icons'

// Constants
import { ROUTE_PATH } from '@/constants/routePath'

// Styles
import styles from './style.module.scss'
import { useTranslation } from 'next-i18next'

const cx = classnames.bind(styles)

const Home = () => {
  const { t } = useTranslation()

  return (
    <div className={cx('home')}>
      <ApplyRoleEntryCard
        title={t('Home_Apply_Merchant_Title')}
        description={
          <div>
            {t('Home_Apply_Merchant_Description_1')}
            <br />
            <br />
            {t('Home_Apply_Merchant_Description_2')}
          </div>
        }
        image='/images/home/home_apply_merchant.png'
        icon={<Icon.HomeMerchant />}
        buttonText={t('Common_Start')}
        buttonLink={ROUTE_PATH.APPLY_MERCHANT}
      />
      <ApplyRoleEntryCard
        title={t('Home_Apply_KOL_Title')}
        description={
          <div>
            {t('Home_Apply_KOL_Description_1')}
            <br />
            <br />
            {t('Home_Apply_KOL_Description_2')}
          </div>
        }
        image='/images/home/home_apply_merchant.png'
        icon={<Icon.HomeKol />}
        buttonText={t('Common_Start')}
        buttonLink={ROUTE_PATH.APPLY_KOL}
      />
    </div>
  )
}

export default Home
